import '../OEmbedProvider';
import { OEmbedProvider } from '../OEmbedProvider';

/**
 * YouTube oembed provider.
 */
export const FacebookProvider: OEmbedProvider = {
    name: 'facebook',
    type: 'rich',
    format: 'json',
    api: 'https://TODO',
    urls: [
        "facebook.com",
    ],
};
